class KlaviyoTracker {
  constructor() {
    this._learnq = window._learnq || [];
  }

  formatMoney(cents = false, format) {
    if (!cents && cents !== 0) return;
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.bva.moneyFormat;

    const centsArray = cents.toString().split('');
    const hasTrailingZeros = centsArray[centsArray.length - 1] == '0' && centsArray[centsArray.length - 2] == '0';
    const precision = hasTrailingZeros ? 0 : 2;

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = this.formatWithDelimiters(cents, precision);
        break;
      case 'amount_with_decimals':
        value = this.formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = this.formatWithDelimiters(cents, precision);
        break;
      case 'amount_with_comma_separator':
        value = this.formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = this.formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  formatWithDelimiters = (number, precision, thousands, decimal) => {
    precision = this.defaultOption(precision, 2);
    thousands = this.defaultOption(thousands, ',');
    decimal = this.defaultOption(decimal, '.');
  
    if (isNaN(number) || number == null) {
      return 0;
    }
  
    number = (number / 100.0).toFixed(precision);
  
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
  
    return dollars + cents;
  };

  defaultOption = (opt, def) => {
    return typeof opt == 'undefined' ? def : opt;
  };

  getKlaviyoItemCartData(variantData) {
    const variant = variantData;

    return {
      Name: variant.title,
      ProductID: variant.product_id,
      Categories: variant.product_type,
      ImageURL: variant.featured_image.url,
      URL: `${window.location.origin}${variant.url}`,
      Brand: variant.vendor,
      Price: this.formatMoney(variant.price, '${{amount}}'),
      CompareAtPrice: variant.compare_at_price ? this.formatMoney(variant.compare_at_price, '${{amount}}') : null,
    };
  }

  getKlaviyoItemViewData() {
    const productJsonScript = document.querySelector('script[data-product-json]');
    const product = JSON.parse(productJsonScript.textContent);
    // get the current variant id from URL query params id or window.defaultProductVariant if not available
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || window.defaultProductVariant.id;
    const variant = product.variants.find((variant) => variant.id == variantId);

    return {
      Name: variant.title,
      ProductID: product.id,
      Categories: product.type,
      ImageURL: `https:${variant.featured_image.src}`,
      URL: `${window.location.origin}/products/${product.handle}?variant=${variant.id}`,
      Brand: product.vendor,
      Price: this.formatMoney(variant.price, '${{amount}}'),
      CompareAtPrice: variant.compare_at_price ? this.formatMoney(variant.compare_at_price, '${{amount}}') : null,
    };
  }

  pushAddToCartData(variantData) {
    const item = this.getKlaviyoItemCartData(variantData);
    this._learnq.push(['track', 'Add To Cart', item]);
  }

  pushViewProductData() {
    const item = this.getKlaviyoItemViewData();
    this._learnq.push(['track', 'Viewed Product', item]);
    this._learnq.push([
      'trackViewedItem',
      {
        Title: item.Name,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice,
        },
      },
    ]);
  }

}

new KlaviyoTracker();